<template>
    <div>
        <header-message class="mt-3 mb-3 text-warning">Auggie Device Upgrade Failed</header-message>
        <header-message class="mb-3">
            The package download and install failed. {{ abortError }}
        </header-message>
        <header-message class="mb-3">
            When the device is restarted, another upgrade will be attempted.
        </header-message>
        <div class="buttondiv mt-5 mb-5">
            <button-button class="btn btn-primary" type="submit" @click.prevent="restartClicked">Restart</button-button>
        </div>
        <power-off />
    </div>
</template>

<style scoped lang="scss">
    .buttondiv {
        text-align:center;
    }
</style>

<style lang="scss">
    .desc.status {
        font-size: 1.5rem;
        font-style: normal;
    }
</style>

<script lang="ts">

import { defineComponent } from "vue";

import PageBase from "@/shared/components/common/PageBase";
import HeaderMessage from "@/components/HeaderMessage.vue";
import PowerOff from "@/components/PowerOff.vue";

export default defineComponent({
    name: "UpgradeFailed",
    mixins: [PageBase],
    components: {
        HeaderMessage,
        PowerOff,
    },
    computed: {
        abortError(): string {
            const err = Auggie.PackageDownload.AbortError();
            if (!err) return "";
            return ` ${err}`;
        },
    },
    methods: {
        restartClicked(): void {
            Auggie.System.Restart();
        },
    },
});
</script>
